import {
  InnerWavePath,
  MaskRect,
  MutedMarkPath,
  OuterWavePath,
  Props,
} from "./SpeakerIcon.Parts";

/**
 * A single icon whose paths animate between "audible" and "muted" states, rather than swapping to a different glyph
 */
export const SpeakerIcon = ({
  $muted = false,
  $maskFill = "none",
  ...props
}: Props) => (
  <svg
    viewBox="0 0 21 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="19"
    {...props}
  >
    <MutedMarkPath
      $muted={$muted}
      fill="currentColor"
      d="M17.9049 7.41965L18.823 8.33771C18.9078 8.42247 18.9075 8.55926 18.823 8.64373L17.4667 10L18.823 11.3563C18.9078 11.441 18.9075 11.5778 18.823 11.6623L17.9049 12.5803C17.8205 12.6648 17.6837 12.6651 17.5989 12.5803L16.2426 11.2241L14.8864 12.5803C14.8019 12.6648 14.6651 12.6651 14.5803 12.5803L13.6623 11.6623C13.5778 11.5778 13.5778 11.4407 13.6623 11.3563L15.0186 10L13.6623 8.64373C13.5778 8.55926 13.5778 8.42217 13.6623 8.33771L14.5803 7.41965C14.6648 7.33519 14.8019 7.33519 14.8864 7.41965L16.2426 8.77593L17.5989 7.41965C17.6834 7.33519 17.8205 7.33519 17.9049 7.41965Z"
    />
    <OuterWavePath
      $muted={$muted}
      fill="currentColor"
      d="M16.512 16.9906L15.6071 16.0387C15.4758 15.9006 15.4734 15.6781 15.6002 15.5348C18.8454 11.8649 18.8454 6.14944 15.6002 2.47951C15.4734 2.33621 15.4758 2.11376 15.6071 1.97564L16.512 1.02375C16.6487 0.879934 16.8724 0.882004 17.0052 1.03048C20.9984 5.50433 20.9984 12.5105 17.0052 16.9844C16.8729 17.1328 16.6492 17.1349 16.512 16.9911V16.9906Z"
    />
    <InnerWavePath
      $muted={$muted}
      fill="currentColor"
      d="M14.0763 14.4277L13.171 13.4753C13.0421 13.3398 13.0358 13.122 13.1567 12.9797C14.0852 11.8866 14.5932 10.4888 14.5932 9.00718C14.5932 7.52555 14.0857 6.12721 13.1567 5.03462C13.0353 4.89183 13.0421 4.67404 13.171 4.53901L14.0763 3.58661C14.216 3.43969 14.4432 3.44693 14.576 3.60058C15.858 5.08117 16.5598 6.9865 16.5598 9.00718C16.5598 11.0279 15.858 12.9332 14.576 14.4138C14.4432 14.5674 14.2155 14.5747 14.0763 14.4277Z"
    />
    <MaskRect $maskFill={$maskFill} width="12" height="19" />
    <path
      d="M11.5855 0.0491087L4.93143 5.08375H0.245883C0.110156 5.08375 0 5.19963 0 5.34241V13.2819C0 13.4226 0.107205 13.5374 0.240965 13.54L5.25403 13.6419L11.5855 18.4319C11.7483 18.555 11.975 18.4329 11.975 18.2218V0.259144C11.975 0.0485913 11.7483 -0.0740155 11.5855 0.0491087ZM4.53753 11.2762C4.53753 11.419 4.42737 11.5348 4.29165 11.5348H2.21295C2.07624 11.5348 1.96559 11.4174 1.96707 11.2741L1.99952 7.40914C2.001 7.2674 2.11066 7.15306 2.24541 7.15306H4.29165C4.42737 7.15306 4.53753 7.26843 4.53753 7.41173V11.2762ZM10.0079 14.1851C10.0079 14.3957 9.78123 14.5183 9.61846 14.3951L6.60688 12.1168C6.54246 12.0682 6.50459 11.9901 6.50459 11.9068V6.57521C6.50459 6.49192 6.54246 6.4138 6.60688 6.36517L9.61846 4.08634C9.78123 3.96322 10.0079 4.08531 10.0079 4.29638V14.1851Z"
      fill="currentColor"
    />
  </svg>
);
